import * as React from "react";
import {
  PodCastWrapper
} from "./pod-cast.style";
import { FC } from "preact/compat";
import { Player } from "../player/player.styled";
import { RefObject } from "preact";
import { BsPause, BsPlay } from "react-icons/bs";

interface PodCastProps {
  link?: string;
  className?: string;
  isPlaying: boolean;
  songInfo: Record<string, any>;
  setIsPlaying: (isPlaying: boolean) => void;
  audioRef: RefObject<HTMLAudioElement>;
  data: any;
}

const PodCast: FC<PodCastProps> = ({
                                     link,
                                     setIsPlaying,
                                     className,
                                     audioRef,
                                     isPlaying,
                                     data,
                                     songInfo,
                                     ...props
                                   }) => {
  const addAllClasses = [""];
  if (className) {
    addAllClasses.push(className);
  }
  const getTime = (time: number) => {
    if (time) {
      return (
        Math.floor(time / 60) + ":" + ("0" + Math.floor(time % 60)).slice(-2)
      );
    }
  };
  const playHandler = () => {
    console.log("play", audioRef);
    if (isPlaying) {
      audioRef.current?.pause();
      setIsPlaying(!isPlaying);
    } else {
      audioRef.current?.play();
      setIsPlaying(!isPlaying);
    }
  };
  return (
    <PodCastWrapper className={addAllClasses.join(" ")} {...props}>
      <Player>
        <div className={"time-control"}>
          <span>{getTime(songInfo.currentTime) || "0:00"}</span>
          <input type="range" min={0} max={songInfo.duration.toString()} />
          <span>{getTime(songInfo.duration)}</span>
        </div>
        {!isPlaying ?
          <BsPlay cursor={"pointer"} fontSize={20} onClick={playHandler}> </BsPlay>
          : <BsPause cursor={"pointer"} fontSize={20} onClick={playHandler}></BsPause>
        }
      </Player>
    </PodCastWrapper>
  );
};

export default PodCast;
